import { fg } from '@atlaskit/platform-feature-flags/fg';

import { PrimaryProductKeys } from '../constants/primary-product-keys';
import {
	type PrimaryProductKey,
	ProductKeys,
	PRODUCTS_ORDER_WITH_3P_BY_POPULARITY,
} from '../constants/product-keys';

export const getProductsOrderByPrimaryProduct: (
	primaryProduct: PrimaryProductKey | undefined,
) => ProductKeys[] = (primaryProduct: PrimaryProductKey | undefined): ProductKeys[] => {
	if (primaryProduct === PrimaryProductKeys.Assets) {
		return [ProductKeys.Assets, ...PRODUCTS_ORDER_WITH_3P_BY_POPULARITY];
	}

	if (primaryProduct === PrimaryProductKeys.Jira) {
		const jiraProducts: ProductKeys[] = [
			ProductKeys.Jira,
			ProductKeys.Confluence,
			ProductKeys.JiraProductDiscovery,
			ProductKeys.JiraServiceManagement,
		];
		// Bring all Jira products to the top
		return [
			...jiraProducts,
			...PRODUCTS_ORDER_WITH_3P_BY_POPULARITY.filter((key) => !jiraProducts.includes(key)),
		];
	}

	if (primaryProduct === PrimaryProductKeys.Loom && fg('loom-rovo-search')) {
		return [
			ProductKeys.Loom,
			...PRODUCTS_ORDER_WITH_3P_BY_POPULARITY.filter((key) => key !== ProductKeys.Loom),
		];
	}

	return PRODUCTS_ORDER_WITH_3P_BY_POPULARITY;
};
